import { Resources, useResource } from "Infrastructure/Translation/Resources";
import type { CustomerEditFormModel } from "Order/Components/Form/Schema/customerEditSchema";
import { BaseCard } from "Shared/Components/Cards/BaseCard";
import type { FC } from "react";
import type { UseFormReturn } from "react-hook-form";
import { CustomerEditForm } from "../Components/Form/CustomerEditForm";

type Props = {
	form: UseFormReturn<CustomerEditFormModel>;
};

const orderResources = Resources.base.order.detail;

export const CustomerEditWidget: FC<Props> = ({ form }) => {
	const { t } = useResource();
	return (
		<BaseCard title={t(orderResources.info.titleCustomer)}>
			<CustomerEditForm form={form} />
		</BaseCard>
	);
};
